module.exports = __webpack_public_path__ + "static/media/safari.8fc2a5ee.png";